import { cn } from '@/lib/utils';
import { env } from '@/config/env';
import logoMark from '@/assets/logo-mark.svg';
import logoWordmark from '@/assets/logo-wordmark.svg';

const SIZES = {
  md: {
    box: 'h-9 w-[154px]',
    mark: 'h-9 w-[30px]',
    word: 'left-[40px] top-[10px] h-[21px] w-[115px]',
  },
  sm: {
    box: 'h-7 w-[120px]',
    mark: 'h-7 w-[24px]',
    word: 'left-[31px] top-2 h-4 w-[89px]',
  },
} as const;

interface MoneyFoxLogoProps {
  size?: keyof typeof SIZES;
  className?: string;
}

export function MoneyFoxLogo({ size = 'md', className }: MoneyFoxLogoProps) {
  const dims = SIZES[size];
  return (
    <div
      className={cn('relative shrink-0 overflow-clip', dims.box, className)}
      role="img"
      aria-label={env.VITE_APP_NAME}
    >
      <img src={logoMark} alt="" className={cn('absolute left-0 top-0', dims.mark)} />
      <img src={logoWordmark} alt="" className={cn('absolute', dims.word)} />
    </div>
  );
}
